/** @jsx jsx */
import { gql } from '@apollo/client';
import {
  Box,
  Button,
  DownloadIcon,
  ShoppingCartIcon,
} from '@bottlebooks/gatsby-theme-base';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import React from 'react';
import { jsx } from 'theme-ui';

export default function ProductActions({ product }) {
  return (
    <React.Fragment>
      <OnlineShopButton product={product} sx={{ marginRight: 2 }} />
      <InfoSheetButton product={product} sx={{ marginRight: 2 }} />
    </React.Fragment>
  );
}

export function OnlineShopButton({ product, className }) {
  const shopUrl = product?.onlineShop || product?.producer?.onlineShop;
  if (!shopUrl) return null;
  return (
    <Button
      href={shopUrl}
      target="_blank"
      rel="noopener noreferrer"
      variant="primary"
      sx={{ paddingX: 4, paddingY: 2, alignItems: 'center' }}
      className={className}
    >
      <ShoppingCartIcon
        size="small"
        sx={{ marginRight: 2, color: 'currentColor' }}
      />
      {product.onlineShop ? (
        <Trans>Buy online</Trans>
      ) : (
        <Trans>Go to online shop</Trans>
      )}
      {product.price && (
        <Box sx={{ display: 'inline', paddingLeft: 2, opacity: 0.8 }}>
          {product.price} EUR
        </Box>
      )}
    </Button>
  );
}

export function InfoSheetButton({ product, className }) {
  if (!product?.infoSheet?.url) return null;
  return (
    <Button
      href={product.infoSheet.url}
      target="_blank"
      rel="noopener noreferrer"
      variant="outline"
      sx={{ paddingX: 4, paddingY: 2, alignItems: 'center' }}
      className={className}
    >
      <DownloadIcon
        size="small"
        sx={{ marginRight: 2, color: 'currentColor' }}
      />
      <Trans>Download info sheet</Trans>
    </Button>
  );
}

export const fragment = graphql`
  fragment ProductActions on Product {
    producer {
      onlineShop
    }
    onlineShop: webshop
    price
    bottleSize
    infoSheet {
      url
    }
  }
`;

export const ProductActionsFragment = gql`
  fragment ProductActions on Product {
    producer {
      onlineShop(format: URL)
    }
    onlineShop(format: URL)
    # price TODO not yet available on api.bottlebooks.me
    # bottleSize TODO not yet available on api.bottlebooks.me
    infoSheet {
      url
    }
  }
`;
